var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('supplier-search-page',{staticClass:"js-by-product-SSF",attrs:{"ignite":_vm.ignite,"dataFromBus":_vm.dataFromExternal},on:{"off":function($event){_vm.ignite = false}}})}
var staticRenderFns = []

export { render, staticRenderFns }